import { useState } from "react";
import usePageTitle from "../pageTitle";
import AppConfig from "../../appConfig";
import {
  Box,
  Backdrop,
  Alert,
  Snackbar,
  CircularProgress,
  Typography,
  Paper,
  Button,
  Icon,
} from "@mui/material";

function InstagramInsightsApprovalAuthPage() {
  usePageTitle("Instagram Profile Link");

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  return (
    <>
      <Box mb={5}>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {errorMsg}
          </Alert>
        </Snackbar>
      </Box>
      <Box
        mt={10}
        sx={{ width: "100%", maxWidth: "480px", margin: "55px auto" }}
      >
        <Paper elevation={3}>
          <Box p={3} align="center">
            <Box mb={5}>
              <Typography variant="h6">Login To Instagram</Typography>
            </Box>
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={() => {
                window.location.href = `${AppConfig.api_base_url}sm/instagram/approval/insights/auth.json`;
              }}
              startIcon={<Icon>login</Icon>}
            >
              Login
            </Button>
          </Box>
        </Paper>
      </Box>
    </>
  );
}

export default InstagramInsightsApprovalAuthPage;
